export default __webpack_public_path__ + "static/logo-d8ffb140703c6055c1f5b3613635291e.png";